import * as React from 'react';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { Card, CardBody } from 'reactstrap';
import { ButtonsContainer } from './styled';
import AppButton from '../../../components/AppButton';

export interface SettingsItemContentProps {
    id: string
    values: any
    onChange: (value: any, save?: boolean) => void
    onValidationChange?: (isValid: boolean) => void
}

export interface GeneralSettingsProps {
    id: string,
    title: string,
    values: any,
    hideButtons?: boolean,
    contentComponentType: React.ComponentType<SettingsItemContentProps>,
    onLoad?: () => void,
    onSave?: (values: any) => void,
    footerLeft?: React.ReactNode,
}

const GeneralSettings: React.FC<GeneralSettingsProps> = (props) => {
    const {
        id,
        title,
        values,
        hideButtons,
        onLoad,
        onSave,
        footerLeft,
        contentComponentType: Content,
    } = props;

    const t = useTranslations();

    // eslint-disable-next-line
    React.useEffect(() => {onLoad && onLoad()}, []);

    const [edited, setEdited] = React.useState(values);
    const [isValid, setIsValid] = React.useState(true);

    const handleDiscard = () => { setEdited(values) };
    const handleSave = () => onSave && onSave(edited);
    const handleChange = (value: any, save?: boolean) => {
        setEdited(value);
        if(save && onSave) onSave(value);
    }
    const handleValidationChange = (valid: boolean) => {
        setIsValid(valid);
    }

    return (<>

        <h4 style={{
            color: 'var(--text-body)',
            marginBottom: 'var(--spacer-S)',
            fontSize: '1.25rem',
            fontWeight: 600
        }}>
            {title}
        </h4>
        <Card style={{ marginBottom: 'var(--spacer-M)' }}>
            <CardBody>
                <Content
                    id={`${id}-content`}
                    values={edited}
                    onChange={handleChange}
                    onValidationChange={handleValidationChange}
                />
                {!hideButtons && onSave && (
                    <ButtonsContainer>
                        {footerLeft ? <div style={{marginRight: 'auto'}}>{footerLeft}</div> : null}
                        <AppButton id={`${id}-discard-button`} onClick={handleDiscard}>{t(TK.discard)}</AppButton>
                        <AppButton id={`${id}-save-button`} color="success" onClick={handleSave} disabled={!isValid}>{t(TK.save)}</AppButton>
                    </ButtonsContainer>
                )}
            </CardBody>
        </Card>
    </>);
}

export default GeneralSettings;
